import React from 'react';
import AdminLayout from '../../components/templates/layout/AdminLayout';
import CPCManagement from '../../components/templates/admin/CPCManagement';

const CPCManagementPage = () => {
  return (
    <AdminLayout>
      <CPCManagement />
    </AdminLayout>
  );
};

export default CPCManagementPage;
